import { environment } from '../../../environments/environment';

export let API_BASE_URL = normalizeApiBaseUrl(environment.apiBaseUrl);

export function setApiBaseUrl(url: string): void {
  API_BASE_URL = normalizeApiBaseUrl(url);
}

function normalizeApiBaseUrl(url: string): string {
  const trimmed = (url ?? '').trim();
  if (!trimmed) {
    return '/api';
  }
  return trimmed.replace(/\/+$/, '');
}
